<template>
  <div>
    <section v-if="content.body.length">
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
          <template>
            <div class="flex-shrink-1">
              <v-btn
                class="text-capitalize"
                text
                :color="$buttonColor"
                @click="more()"
              >
                See More
                <v-icon right small>far fa-chevron-right</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>

      <v-row class="mt-1">
        <template v-for="item of content.body">
          <v-col
            cols="12"
            sm="6"
            lg="4"
            xl="3"
            class="pr-5"
            :key="`course_${item._id}`"
            @click="navigate(item)"
          >
            <v-hover v-slot:default="{ hover }">
              <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }"> -->
              <v-card
                class="recCourseCustomCard hoverable card-growable"
                elevation="0"
                ripple=""
              >
                <v-img
                  class="recCourseImage"
                  :src="item.image"
                  :lazy-src="item.image"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-sheet
                        width="100%"
                        height="100%"
                        color="grey lighten-3"
                        class="d-flex justify-center"
                      >
                        <v-icon x-large color="grey lighten-1"
                          >mdi mdi-image-area</v-icon
                        >
                      </v-sheet>
                    </v-row>
                  </template>
                </v-img>
                <v-row>
                  <v-col>
                    <div
                      :style="{
                        color: `${$themeColor}`,
                        fontSize: `13px`,
                        fontWeight: `500`,
                        marginTop: `8px`,
                        marginBottom: `8px`,
                      }"
                      v-text="item.categories[0].title"
                    ></div>
                    <div class="myCourseTitle">{{ item.title }}</div>
                    <div class="recInstructor">
                      {{ item.owner_by_students[0]._id.displayName }}
                    </div>
                    <div class="d-flex" style="align-items: center">
                      <div>
                        <v-rating
                          half-increments
                          half-icon="fas fa-star-half-alt"
                          background-color="grey"
                          color="amber"
                          readonly
                          dense
                          x-small
                          :value="item.rating"
                        ></v-rating>
                      </div>
                      <div class="ml-2 my-auto flex-grow-1">
                        <p class="mt-1 mb-0 body-2">{{ item.rating }}</p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ml-2 flex-grow-1 text-end">
                        <p
                          v-if="item.bundle.length"
                          class="mb-0 subtitle-1 font-weight-black"
                        >
                          ฿{{
                            item.bundle.length
                              ? numberWithCommas(item.bundle[0].price)
                              : 0
                          }}
                        </p>
                        <p v-else class="mb-0 subtitle-1 font-weight-black">
                          Free
                        </p>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
              <!-- </template>
              <span>{{ item.title }}</span>
            </v-tooltip> -->
            </v-hover>
          </v-col>
        </template>
        <!-- <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" class="pr-5">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="recCourseCustomCard hoverable card-growable"
            elevation="0"
            ripple=""
          >
            <v-img
              class="recCourseImage"
              src="https://s3-amr.deknerd.com/template/certificates/certificate1.png"
            >
            </v-img>
            <v-row>
              <v-col>
                <div class="myCourseCatagory">Catagory</div>
                <div class="myCourseTitle">Title</div>
                <div class="recInstructor py-2">FirstName Lastname</div>
                <div>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star checked"></span>
                  <span class="fa fa-star unchecked"></span>
                  <span class="fa fa-star unchecked"></span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col> -->
      </v-row>
    </section>
    <section v-else>
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
          </div>
        </div>
        <div
          class="subtitle-1 grey--text text--darken-2"
          v-text="content.subtitle"
        ></div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
function compare(a, b) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}

export default {
  data: () => ({
    default_limit: 4,
  }),
  name: "course_vertical_gridview",
  props: ["content", "md", "lg"],
  computed: {
    lgComputed() {
      if (this.lg != null && this.lg != 0) {
        return this.lg;
      }

      return 3;
    },
    mdComputed() {
      if (this.md != null && this.md != 0) {
        return this.md;
      }
      return 4;
    },
  },
  async mounted() {
    this.default_limit = this.content.body.length;
    await this.fetchBundle();
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchBundle() {
      var sortable = [];
      console.log(this.content.body);
      this.content.body.forEach((element) => {
        if (element.bundle.length) {
          sortable = element.bundle.sort(compare);
        } else {
          // no bundle
        }
      });
      console.log(sortable);
    },

    more() {
      // const qs = this.$utility.queryStringToJson(
      //   flag == "footer"
      //     ? this.content.footerButton.queries
      //     : this.content.headerButton.queries
      // );
      const qs = this.content.footerButton
        ? this.content.footerButton.queries
        : this.content.headerButton.queries;

      console.log("more -> qs", qs);

      let sorting = qs.filter((query) => query.param == "sort")[0].value;
      let sortingby = qs.filter((query) => query.param == "sortby")[0].value;
      let searching = qs.filter((query) => query.param == "search")[0];
      // let category = qs.filter((query) =>  query.param == "category")[0].value;
      let category = null;
      qs.forEach((query) => {
        if (query.param == "category") {
          category = query.value;
        }
      });

      if (searching) {
        searching = searching.value;
      } else {
        searching = null;
      }
      this.$router.push({
        name: "course",
        query: {
          sort: sorting,
          sortby: sortingby,
          page: 1,
          limit: 10,
          title: this.content.title,
          search: searching,
          category: category,
        },
      });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style scoped>
.myCourseCatagory {
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
}
.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}

.recCourseCustomCard {
  border-radius: 4px;
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}

.recCourseImage {
  width: 100%;
  height: 200px;
}

.recInstructor {
  font-size: 14px;
  line-height: 1.57;
  color: #9b9b9b;
  margin-top: 8px;
  margin-bottom: 8px;
}

.checked {
  color: #fadb14;
  font-size: 16px;
}

.unchecked {
  color: rgba(0, 0, 0, 0.04);
  font-size: 16px;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
</style>
